import React from "react"
import autobind from "class-autobind"
import strings from "../../../../localization/strings"
import AccountStore from "../../../../stores/AccountStore"
import AppStateStore from "../../../../stores/AppStateStore"
import AuthenticationStore from "../../../../stores/AuthenticationStore"
import * as permissionHelper from "../../../../helpers/permissionHelper"
import { Checkbox, SelectField, MenuItem, FlatButton, Table, TableBody, TableRow, TableRowColumn, TableHeader, TableHeaderColumn, IconButton, FontIcon } from "material-ui"
import { amber500, red500, grey200, grey300 } from "material-ui/styles/colors"
import ChooseCSVFile from "../../../../components/common/ChooseCSVFile"
import ErrorIcon from "material-ui/svg-icons/alert/error"
import * as importActions from "../../../../actions/ImportActions"
import { checkPositionFieldAvailable } from "../../../../helpers/positionHelper"
import { checkJobFieldAvailable } from "../../../../helpers/jobHelper"
import { checkPhaseFieldAvailable } from "../../../../helpers/punchHelper"
interface IState {
    selectedImportType: string
    csvFileData: string[][]
    csvFile: File
    showChooseCSVFile: boolean
    importErrors: string[]

    //Import schedule
    importAsPostedSchedule: boolean
}

export default class ImportCard extends React.Component<{}, IState> {
    private allowedImportPermissions: string[]
    // for punch
    private importPunchHeaderCols: string[]
    private requiredImportPunchHeaderCols: string[]
    // for expense time
    private importExpenseTimeHeaderCols: string[]
    private requiredImportExpenseTimeHeaderCols: string[]
    // for expense amount
    private importExpenseAmountHeaderCols: string[]
    private requiredImportExpenseAmountHeaderCols: string[]
    // for employee import
    private importEmployeesHeaderCols: string[]
    private requiredImportEmployeesHeaderCols: string[]
    private importEmployeesSampleCSVFileURL: string
    // for job import
    private importJobsHeaderCols: string[]
    private requiredImportJobsHeaderCols: string[]
    private importJobsSampleCSVFileURL: string
    // for schedule import
    private importScheduleHeaderCols: string[]
    private requiredImportScheduleHeaderCols: string[]


    private defaultImportAsPostedSchedule = false
    constructor(props) {
        super(props)
        this.state = {
            selectedImportType: null,
            csvFileData: null,
            csvFile: null,
            showChooseCSVFile: true,
            importErrors: [],
            importAsPostedSchedule: this.defaultImportAsPostedSchedule,
        }
        autobind(this)
        this.allowedImportPermissions = permissionHelper.allowedImportPermissions()

        const employeeExternalIdColTitle = "Employee ExternalId"
        const punchCostCenterColTitle = "Punch CostCenter"
        const positionCostCenterColTitle = checkPositionFieldAvailable('singular') ? `${AccountStore.getCurrentAccountSettings().CustomFieldSettings.PositionFieldLabels.SingularPositionLabel} CostCenter` : "Position CostCenter"
        const equipmentExternalIdColTitle = "Equipment ExternalId"
        const payTypeCodeColTitle = "PayTypeCode"
        const dateTimeColTitle = "DateTime"
        this.importPunchHeaderCols = [employeeExternalIdColTitle, punchCostCenterColTitle, positionCostCenterColTitle]
        AccountStore.getEquipmentEnabled() &&
            this.importPunchHeaderCols.push(equipmentExternalIdColTitle)
        this.importPunchHeaderCols.push(payTypeCodeColTitle)
        this.importPunchHeaderCols.push(dateTimeColTitle)
        this.requiredImportPunchHeaderCols = [employeeExternalIdColTitle, punchCostCenterColTitle, dateTimeColTitle]

        const expenseNameColTitle = "Expense Name"
        const taxableColTitle = "Taxable"
        const expenseDateColTitle = "Date"
        const expenseTimeColTitle = "Hours"
        const expenseAmountColTitle = "Amount"
        const expenseHierarchyCostCenterColTitle = "Hierarchy Cost Center"
const expensePositionCostCenterColTitle = checkPositionFieldAvailable('singular') ? `${AccountStore.getCurrentAccountSettings().CustomFieldSettings.PositionFieldLabels.SingularPositionLabel} Cost Center`: "Position Cost Center"
        const expenseJobCostCenterColTitle = checkJobFieldAvailable('singular') ? `${AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.SingularJobLabel} Cost Center` :"Job Cost Center"
        const expensePhaseCostCenterColTitle = checkPhaseFieldAvailable("singular") ? `${AccountStore.getCurrentAccountSettings().CustomFieldSettings.PhaseFieldLabels.SingularPhaseLabel} Cost Center` : "Phase Cost Center"
        this.importExpenseTimeHeaderCols = [employeeExternalIdColTitle, expenseNameColTitle, payTypeCodeColTitle, taxableColTitle, expenseDateColTitle, expenseTimeColTitle, expenseHierarchyCostCenterColTitle, expensePositionCostCenterColTitle]
        AccountStore.getJobsEnabled() && this.importExpenseTimeHeaderCols.push(expenseJobCostCenterColTitle)
        AccountStore.getPhasesEnabled() && this.importExpenseTimeHeaderCols.push(expensePhaseCostCenterColTitle)
        this.requiredImportExpenseTimeHeaderCols = [employeeExternalIdColTitle, expenseNameColTitle, payTypeCodeColTitle, expenseDateColTitle, expenseTimeColTitle, expenseHierarchyCostCenterColTitle]

        this.importExpenseAmountHeaderCols = [employeeExternalIdColTitle, expenseNameColTitle, payTypeCodeColTitle, taxableColTitle, expenseDateColTitle, expenseAmountColTitle, expenseHierarchyCostCenterColTitle, expensePositionCostCenterColTitle]
        AccountStore.getJobsEnabled() && this.importExpenseAmountHeaderCols.push(expenseJobCostCenterColTitle)
        AccountStore.getPhasesEnabled() && this.importExpenseAmountHeaderCols.push(expensePhaseCostCenterColTitle)
        this.requiredImportExpenseAmountHeaderCols = [employeeExternalIdColTitle, expenseNameColTitle, payTypeCodeColTitle, expenseDateColTitle, expenseAmountColTitle, expenseHierarchyCostCenterColTitle]

        const employeeFirstNameColTitle = "Employee First Name"
        const employeeLastNameColTitle = "Employee Last Name"
        const employeeIdColTitle = "Employee Id"
        const punchPermissionHierarchyCostCodeColTitle = "Punch Permission Hierarchy Cost Code"
        const defaultHierarchyCostCodeColTitle = "Default Hierarchy Cost Code"
        const activeColTitle = "Active (T/F)"
        const clockPinColTitle = "Clock Pin"
        const defaultJobIdColTitle =  checkJobFieldAvailable('singular') ? `Default ${AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.SingularJobLabel} Id`:"Default Job Id"
        const supervisorAssignmentsColTitle = "Supervisor Assignment(s)"
        const exemptColTitle = "Exempt (T/F)"
        const agencyColTitle = "Agency (T/F)"
        const allowPunchFromPersonalDeviceColTitle = "Allow Punch From Personal Device (T/F)"
        const hireDateColTitle = "Hire Date (year-month-day / xxxx-xx-xx)"
        const customField1ColTitle = "Custom Field 1"
        const customField2ColTitle = "Custom Field 2"
        const customField3ColTitle = "Custom Field 3"
        const customField4ColTitle = "Custom Field 4"

        this.importEmployeesHeaderCols = [employeeFirstNameColTitle, employeeLastNameColTitle, employeeIdColTitle, punchPermissionHierarchyCostCodeColTitle, defaultHierarchyCostCodeColTitle, activeColTitle, clockPinColTitle, defaultJobIdColTitle, supervisorAssignmentsColTitle, exemptColTitle, agencyColTitle, allowPunchFromPersonalDeviceColTitle, hireDateColTitle, customField1ColTitle, customField2ColTitle, customField3ColTitle, customField4ColTitle]
        this.requiredImportEmployeesHeaderCols = [employeeFirstNameColTitle, employeeLastNameColTitle, employeeIdColTitle, punchPermissionHierarchyCostCodeColTitle, defaultHierarchyCostCodeColTitle, activeColTitle, exemptColTitle, agencyColTitle, allowPunchFromPersonalDeviceColTitle]
        this.importEmployeesSampleCSVFileURL = "https://findd-web.s3.us-west-2.amazonaws.com/assets/Employee Import Sample.csv"


        const jobNameColTitle = checkJobFieldAvailable('singular') ? `${AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.SingularJobLabel} Name`: "Job Name"
        const hierarchyCostCodeColTitle = "Hierarchy Cost Code"
        const jobIdColTitle = checkJobFieldAvailable('singular') ? `${AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.SingularJobLabel} Id`: "Job Id"
        const costCodeColTitle = "Cost Code"
        const noteColTitle = "Note"
        const fullAddressColTitle = "Full Address"
        const clientIdColTitle = "Client Id"

        this.importJobsHeaderCols = [jobNameColTitle, hierarchyCostCodeColTitle, jobIdColTitle, costCodeColTitle, noteColTitle, fullAddressColTitle]
        AccountStore.getClientsEnabled() &&
            this.importJobsHeaderCols.push(clientIdColTitle)
        this.importJobsHeaderCols.push(customField1ColTitle)
        this.importJobsHeaderCols.push(customField2ColTitle)
        this.importJobsHeaderCols.push(customField3ColTitle)
        this.importJobsHeaderCols.push(customField4ColTitle)
        this.requiredImportJobsHeaderCols = [jobNameColTitle, hierarchyCostCodeColTitle]
        this.importJobsSampleCSVFileURL = AccountStore.getClientsEnabled() ?
            "https://findd-web.s3.us-west-2.amazonaws.com/assets/Job Import Sample.csv" :
            "https://findd-web.s3.us-west-2.amazonaws.com/assets/Job Import Sample 2.csv"

        const shiftCostCenter = "Shift CostCenter"
        const shiftNameColTitle = "Shift Name"
        const shiftDateColTitle = "Shift Date"
        const startTimeColTitle = "Start Time"
        const endTimeColTitle = "End Time"
        this.importScheduleHeaderCols = [employeeIdColTitle, shiftCostCenter, shiftNameColTitle, shiftDateColTitle, startTimeColTitle, endTimeColTitle, positionCostCenterColTitle, payTypeCodeColTitle]
        this.requiredImportScheduleHeaderCols = [employeeIdColTitle, shiftCostCenter, shiftNameColTitle, shiftDateColTitle, startTimeColTitle, endTimeColTitle, payTypeCodeColTitle]
    }

    getImportTypeLabel(importType) {
        switch (importType) {
            case AuthenticationStore.Permissions.Import.ImportPunchCSV:
                return strings.Punch_Data
            case AuthenticationStore.Permissions.Import.ImportExpenseTimeCSV:
                return strings.Expense_Time_Data
            case AuthenticationStore.Permissions.Import.ImportExpenseAmountCSV:
                return strings.Expense_Amount_Data
            case AuthenticationStore.Permissions.Import.ImportEmployeesCSV:
                return strings.Employee_Import
            case AuthenticationStore.Permissions.Import.ImportJobsCSV:
                return checkJobFieldAvailable('singular') ? `Import ${AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.SingularJobLabel} Data` :  strings.Import_Job_Data
            case AuthenticationStore.Permissions.Import.ImportScheduleCSV:
                return strings.Import_Schedule_Data
        }
    }

    getConfirmDialogContet() {
        const count = this.state.csvFileData.length - 1
        switch (this.state.selectedImportType) {
            case AuthenticationStore.Permissions.Import.ImportPunchCSV:
                return strings.formatString(strings.Are_you_sure_you_want_to_import_punches_This_cannot_be_undone, count) as string
            case AuthenticationStore.Permissions.Import.ImportExpenseTimeCSV:
                return strings.formatString(strings.Are_you_sure_you_want_to_import_expense_time_This_cannot_be_undone, count) as string
            case AuthenticationStore.Permissions.Import.ImportExpenseAmountCSV:
                return strings.formatString(strings.Are_you_sure_you_want_to_import_expense_amount_This_cannot_be_undone, count) as string
            case AuthenticationStore.Permissions.Import.ImportEmployeesCSV:
                return strings.formatString(strings.Are_you_sure_you_want_to_import_employees_This_cannot_be_undone, count) as string
            case AuthenticationStore.Permissions.Import.ImportJobsCSV:
                return strings.formatString(strings.Are_you_sure_you_want_to_import_jobs_This_cannot_be_undone, count) as string
            case AuthenticationStore.Permissions.Import.ImportScheduleCSV:
                return strings.formatString(strings.Are_you_sure_you_want_to_import_schedule_This_cannot_be_undone, count) as string
        }
    }

    getImportHeaderCols() {
        switch (this.state.selectedImportType) {
            case AuthenticationStore.Permissions.Import.ImportPunchCSV:
                return this.importPunchHeaderCols
            case AuthenticationStore.Permissions.Import.ImportExpenseTimeCSV:
                return this.importExpenseTimeHeaderCols
            case AuthenticationStore.Permissions.Import.ImportExpenseAmountCSV:
                return this.importExpenseAmountHeaderCols
            case AuthenticationStore.Permissions.Import.ImportEmployeesCSV:
                return this.importEmployeesHeaderCols
            case AuthenticationStore.Permissions.Import.ImportJobsCSV:
                return this.importJobsHeaderCols
            case AuthenticationStore.Permissions.Import.ImportScheduleCSV:
                return this.importScheduleHeaderCols
        }
    }

    getRequiredHeaderCols() {
        switch (this.state.selectedImportType) {
            case AuthenticationStore.Permissions.Import.ImportPunchCSV:
                return this.requiredImportPunchHeaderCols
            case AuthenticationStore.Permissions.Import.ImportExpenseTimeCSV:
                return this.requiredImportExpenseTimeHeaderCols
            case AuthenticationStore.Permissions.Import.ImportExpenseAmountCSV:
                return this.requiredImportExpenseAmountHeaderCols
            case AuthenticationStore.Permissions.Import.ImportEmployeesCSV:
                return this.requiredImportEmployeesHeaderCols
            case AuthenticationStore.Permissions.Import.ImportJobsCSV:
                return this.requiredImportJobsHeaderCols
            case AuthenticationStore.Permissions.Import.ImportScheduleCSV:
                return this.requiredImportScheduleHeaderCols
        }
    }

    getLimitedRowCount(): number {
        switch (this.state.selectedImportType) {
            case AuthenticationStore.Permissions.Import.ImportPunchCSV:
                return 10000
            case AuthenticationStore.Permissions.Import.ImportExpenseTimeCSV:
                return 10000
            case AuthenticationStore.Permissions.Import.ImportExpenseAmountCSV:
                return 10000
            case AuthenticationStore.Permissions.Import.ImportEmployeesCSV:
                return 501
            case AuthenticationStore.Permissions.Import.ImportJobsCSV:
                return 501
            case AuthenticationStore.Permissions.Import.ImportScheduleCSV:
                return 501
        }
    }

    getLimitAlertContent(): string {
        let importType
        switch (this.state.selectedImportType) {
            case AuthenticationStore.Permissions.Import.ImportPunchCSV:
                importType = strings.Punch
                break
            case AuthenticationStore.Permissions.Import.ImportExpenseTimeCSV:
                importType = strings.Expense
                break
            case AuthenticationStore.Permissions.Import.ImportExpenseAmountCSV:
                importType = strings.Expense
                break
            case AuthenticationStore.Permissions.Import.ImportEmployeesCSV:
                importType = strings.Employee
                break
            case AuthenticationStore.Permissions.Import.ImportJobsCSV:
                importType = strings.Job
                break
            case AuthenticationStore.Permissions.Import.ImportScheduleCSV:
                importType = strings.Schedule
                break
        }
        return strings.formatString(strings.x_import_is_limited_to_x_rows, importType, this.getLimitedRowCount(), this.state.csvFileData.length - 1) as string
    }

    getSampleCSVFileURL() {
        switch (this.state.selectedImportType) {
            case AuthenticationStore.Permissions.Import.ImportEmployeesCSV:
                return this.importEmployeesSampleCSVFileURL
            case AuthenticationStore.Permissions.Import.ImportJobsCSV:
                return this.importJobsSampleCSVFileURL
        }
    }

    getHeaderStyle() {
        switch (this.state.selectedImportType) {
            case AuthenticationStore.Permissions.Import.ImportEmployeesCSV:
                return importTableHeaderStyle
            case AuthenticationStore.Permissions.Import.ImportJobsCSV:
                return importTableHeaderStyle
            case AuthenticationStore.Permissions.Import.ImportExpenseTimeCSV:
                return importTableHeaderStyle
            case AuthenticationStore.Permissions.Import.ImportExpenseAmountCSV:
                return importTableHeaderStyle
            default:
                return null
        }
    }

    getHeaderColumnWidth() {
        switch (this.state.selectedImportType) {
            case AuthenticationStore.Permissions.Import.ImportJobsCSV:
                return 252
            case AuthenticationStore.Permissions.Import.ImportExpenseTimeCSV:
                return 252
            case AuthenticationStore.Permissions.Import.ImportExpenseAmountCSV:
                return 252
            default:
                return null
        }
    }

    async handleImport() {
        let result
        switch (this.state.selectedImportType) {
            case AuthenticationStore.Permissions.Import.ImportPunchCSV:
                result = await importActions.importPunchData(this.state.csvFileData)
                break
            case AuthenticationStore.Permissions.Import.ImportExpenseTimeCSV:
                result = await importActions.importExpenseTimeData(this.state.csvFileData)
                break
            case AuthenticationStore.Permissions.Import.ImportExpenseAmountCSV:
                result = await importActions.importExpenseAmountData(this.state.csvFileData)
                break
            case AuthenticationStore.Permissions.Import.ImportEmployeesCSV:
                result = await importActions.importEmployeesData(this.state.csvFile)
                break
            case AuthenticationStore.Permissions.Import.ImportJobsCSV:
                result = await importActions.importJobsData(this.state.csvFile)
                break
            case AuthenticationStore.Permissions.Import.ImportScheduleCSV:
                result = await importActions.importScheduleData(this.state.csvFile, this.state.importAsPostedSchedule)
                break
        }

        this.setState({ showChooseCSVFile: false }, () => this.setState({ showChooseCSVFile: true, csvFileData: null, csvFile: null }))
        result.length > 0 &&
            this.setState({ importErrors: result })
        AppStateStore.setProgressSnackbarContent(result.length === 0 ? strings.Successfully_imported : strings.Failed_to_import)
    }

    render() {
        const importHeaderCols = this.getImportHeaderCols()
        const requiredHeaderCols = this.getRequiredHeaderCols()
        return (
            <div style={{ paddingLeft: 20, paddingRight: 20 }}>
                <div style={{ display: "flex", marginTop: -15 }}>
                    <SelectField
                        data-intercom-target={"menu-AccountSettings-ImportCSVFile-Select-ImportType"}
                        floatingLabelText={strings.Import_Type}
                        style={{ marginTop: 8 }}
                        value={this.state.selectedImportType}
                        onChange={(e, i, selectedImportType) =>
                            this.setState({
                                selectedImportType,
                                showChooseCSVFile: false,
                                csvFileData: null,
                                csvFile: null,
                                importErrors: []
                            }, () =>
                                this.setState({ showChooseCSVFile: true })
                            )
                        }
                    >
                        {this.allowedImportPermissions.map(i =>
                            <MenuItem key={i} value={i} primaryText={this.getImportTypeLabel(i)} />
                        )}
                    </SelectField>
                    {this.state.showChooseCSVFile && this.state.selectedImportType &&
                        <div style={{ marginLeft: 20 }}>
                            <ChooseCSVFile handleChooseFile={(_fileName, csvFileData, csvFile) => this.setState({ csvFileData, csvFile, importErrors: [] })} />
                        </div>
                    }
                    {this.state.csvFileData &&
                        <FlatButton
                            data-intercom-target={"menu-AccountSettings-ImportCSVFile-Btn-POST"}
                            label={strings.Post.toUpperCase()}
                            backgroundColor={amber500}
                            hoverColor={amber500}
                            labelStyle={{ color: "white" }}
                            style={{ marginTop: 17, marginLeft: 20 }}
                            onClick={() =>
                                this.state.csvFileData.length > this.getLimitedRowCount() ?
                                    AppStateStore.setAlertDialogContent({
                                        title: strings.Warning,
                                        content: this.getLimitAlertContent()
                                    }) :
                                    AppStateStore.setConfirmDialogContent({
                                        content: this.getConfirmDialogContet(),
                                        confirm: () => this.handleImport(),
                                        subContext: this.state.selectedImportType === AuthenticationStore.Permissions.Import.ImportScheduleCSV &&
                                            <Checkbox
                                                label={strings.Import_as_Posted_Schedule}
                                                defaultChecked={this.defaultImportAsPostedSchedule}
                                                style={{ marginTop: 20 }}
                                                onCheck={(e, importAsPostedSchedule) => this.setState({ importAsPostedSchedule })}
                                            />
                                    })
                            }
                        />
                    }
                    {(this.state.selectedImportType === AuthenticationStore.Permissions.Import.ImportEmployeesCSV || this.state.selectedImportType === AuthenticationStore.Permissions.Import.ImportJobsCSV) &&
                        <div style={{ marginLeft: "auto", order: 2 }}>
                            <div
                                style={{ display: "flex", backgroundColor: "#ffb301", cursor: "pointer", borderRadius: 5 }}
                                onClick={() => window.location.assign(this.getSampleCSVFileURL())}
                            >
                                <p style={{ color: "white", paddingLeft: 10 }}>{strings.Download_Sample_File}</p>
                                <IconButton style={{ height: 35, width: 35, display: "inline-block", marginRight: 10 }}>
                                    <FontIcon className="fa fa-download" />
                                </IconButton>
                            </div>
                        </div>
                    }
                </div>
                {this.state.selectedImportType &&
                    <div style={{ padding: 10, backgroundColor: grey200 }}>
                        <div style={{ textAlign: "center" }}>{strings.Expected_CSV_File_Format}</div>
                        <Table selectable={false} wrapperStyle={{ marginTop: 5 }}>
                            <TableHeader
                                displaySelectAll={false}
                                adjustForCheckbox={false}
                                enableSelectAll={false}
                                style={this.getHeaderStyle()}
                            >
                                <TableRow style={{ height: 30 }}>
                                    {importHeaderCols.map(col =>
                                        <TableHeaderColumn key={col} style={{ height: 30, width: this.getHeaderColumnWidth(), borderRightStyle: "solid", borderRightColor: grey300, borderRightWidth: 1 }}>
                                            {col}
                                        </TableHeaderColumn>
                                    )}
                                </TableRow>
                                <TableRow style={{ height: 25 }}>
                                    {importHeaderCols.map(col =>
                                        <TableHeaderColumn key={col} style={{ height: 30, borderRightStyle: "solid", borderRightColor: grey300, borderRightWidth: 1 }}></TableHeaderColumn>
                                    )}
                                </TableRow>
                            </TableHeader>
                        </Table>
                        <div style={{ marginTop: 10, fontSize: 12 }}>
                            <span style={{ marginRight: 10 }}>{strings.Required_Columns}:</span>
                            {requiredHeaderCols.map((col, index) =>
                                <span key={index} style={{ marginRight: 10 }}>
                                    {col}{index !== requiredHeaderCols.length - 1 && ","}
                                </span>
                            )}
                        </div>
                        {(this.state.selectedImportType === AuthenticationStore.Permissions.Import.ImportExpenseTimeCSV ||
                            this.state.selectedImportType === AuthenticationStore.Permissions.Import.ImportExpenseAmountCSV) &&
                            <div style={{ fontSize: 12 }}>
                                <span style={{ marginRight: 10 }}>{strings.Warning}:</span>
                                <span>{strings.Taxable_column_should_be_Yes_or_empty}</span>
                            </div>
                        }
                        {this.state.selectedImportType === AuthenticationStore.Permissions.Import.ImportEmployeesCSV &&
                            <div style={{ fontSize: 12 }}>
                                <span style={{ marginRight: 10 }}>{strings.Note_For_Supervisor_Assignment_Column}:</span>
                                <span>{strings.Multiple_Entries_Must_Be_Separated_By}</span>
                            </div>
                        }
                    </div>
                }
                {this.state.importErrors.length > 0 &&
                    <Table selectable={false} wrapperStyle={{ marginTop: 20 }}>
                        <TableHeader
                            displaySelectAll={false}
                            adjustForCheckbox={false}
                            enableSelectAll={false}
                        >
                            <TableRow style={{ height: 30 }}>
                                <TableHeaderColumn style={{ display: "flex", height: 30 }}>
                                    <ErrorIcon style={{ color: red500, width: 25, height: 25, marginRight: 5 }} />
                                    <span style={{ marginTop: 3 }}>{strings.Import_Validation_Issues}</span>
                                </TableHeaderColumn>
                            </TableRow>
                        </TableHeader>
                        <TableBody displayRowCheckbox={false}>
                            {this.state.importErrors.map((errorContent, index) =>
                                <TableRow key={index} style={{ height: 25, borderBottom: "none" }}>
                                    <TableRowColumn style={{ height: 25, whiteSpace: "unset" }}>
                                        <div dangerouslySetInnerHTML={{ __html: errorContent }} />
                                    </TableRowColumn>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                }
            </div>
        )
    }
}

const importTableHeaderStyle = {
    display: "block",
    overflowX: "auto",
    whiteSpace: "nowrap",
}
